export const DATE_OPTIONS = [
  { key: 'HOY', label: 'Hoy' },
  { key: 'AYER', label: 'Ayer' },
  { key: 'ESTA_SEMANA', label: 'Esta semana' },
  { key: 'ESTE_MES', label: 'Este mes' },
];